import { EipError } from '@profile/src/redux/types';
import icWalletError from 'assets/svg/ic_wrong_network_V2.svg';
export const handleWalletError = (error, dependencies) => {
  const {
    showDialog,
    hideDialog,
    handleSwitchToBSC
  } = dependencies;

  switch (error) {
    case EipError.NO_PROVIDER_EXIST:
      {
        showDialog({
          title: 'MetaMask not found',
          description: 'You need to setup MetaMask wallet to continue',
          icon: icWalletError,
          showCloseIcon: true,
          primaryButton: 'Download Metamask',
          onPrimaryButtonPress: () => {
            hideDialog();
            const newTab = window.open('https://metamask.io/', '_blank');
            newTab === null || newTab === void 0 ? void 0 : newTab.focus();
          }
        });
        break;
      }

    case EipError.THETAN_WALLET_NOT_SUPPORT:
      {
        showDialog({
          title: 'Thetan Wallet not found',
          description: 'You need to setup Thetan Wallet to continue',
          icon: icWalletError.src,
          showCloseIcon: true,
          onCloseIconPress: () => hideDialog(),
          primaryButton: 'Download Thetan Wallet',
          onPrimaryButtonPress: () => {
            hideDialog();
            const newTab = window.open('https://chrome.google.com/webstore/detail/bcenedbpaaegpnijoadpdjiachahncdg', '_blank');
            newTab === null || newTab === void 0 ? void 0 : newTab.focus();
          }
        });
        break;
      }

    case EipError.METAMASK_NOT_SUPPORTED:
      {
        showDialog({
          title: 'MetaMask not found',
          description: 'You need to setup MetaMask wallet to continue',
          icon: icWalletError,
          showCloseIcon: true,
          primaryButton: 'Download Metamask',
          onPrimaryButtonPress: () => {
            hideDialog();
            const newTab = window.open('https://metamask.io/', '_blank');
            newTab === null || newTab === void 0 ? void 0 : newTab.focus();
          }
        });
        break;
      }

    case EipError.COINBASE_NOT_SUPPORT:
      {
        showDialog({
          title: 'Coinbase wallet not found',
          description: 'You need to setup Coinbase wallet to continue',
          icon: icWalletError,
          showCloseIcon: true,
          primaryButton: 'Download Coinbase Wallet',
          onPrimaryButtonPress: () => {
            hideDialog();
            const newTab = window.open('https://www.coinbase.com/wallet', '_blank');
            newTab === null || newTab === void 0 ? void 0 : newTab.focus();
          }
        });
        break;
      }

    case EipError.METAMASK_LOCKED:
      {
        showDialog({
          title: 'MetaMask Locked',
          description: 'You need to unlock Metamask to continue',
          icon: icWalletError,
          showCloseIcon: true
        });
        break;
      }

    case EipError.METAMASK_WRONG_CHAIN:
      {
        showDialog({
          title: 'Wrong Network',
          description: 'You need to connect to supported network',
          icon: icWalletError,
          showCloseIcon: true,
          primaryButton: 'Switch to BSC network',
          onPrimaryButtonPress: () => {
            hideDialog();
            handleSwitchToBSC();
          }
        });
        break;
      }

    default:
      {
        break;
      }
  }
};